import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import { setIsShowFindAllViewList } from "../../../actions/transOperationActions";
import { findAllToSearch } from "../../../actions/transOperation_find_Actions";

// import { Checkbox } from 'semantic-ui-react';
import {
  Label,
  Form,
  FormField,
  TextBox,
  CheckBox,
  LinkButton,
} from "rc-easyui";
import ReactDOM from "react-dom";

class FindAllView_input extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        targetString: null,
        isSubtitle: true,
        isMemo: true,
        isCaseSensitivity: false,
        isSource: false,
      },
    };
  }
  async componentDidMount() {
    /*
     * 確認三組案件
     * */
    ReactDOM.findDOMNode(this).addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        this.handleSubmit();
        // console.log(`e.KeyChar ${e.keyCode}`);
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
    }
  }

  handleChange(name, value) {
    let user = Object.assign({}, this.state.user);
    user[name] = value;
    this.setState({ user: user });
  }

  handleSubmit = () => {
    const { data } = this.props.editTable;

    //...
    const { user } = this.state;
    if (user.targetString !== null) {
      //送入檢查
      this.props.findAllToSearch(
        data,
        user.targetString,
        user.isSubtitle,
        user.isMemo,
        user.isCaseSensitivity,
        user.isSource,
        this.props.transOperation.tableColMapping
      );

      //顯示結果view
      // findAllTargetData
      this.props.setIsShowFindAllViewList(true);
    }
  };

  render() {
    const { user } = this.state;

    let mainContent;

    mainContent = (
      <div id={"FindAllView_input"} className="row col-12 small">
        <Form
          style={{ fontSize: "12px", width: 500 }}
          model={user}
          // labelWidth={110}
          labelAlign="left"
          onChange={this.handleChange.bind(this)}
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div>
            <FormField
              name="isSubtitle"
              label="Target"
              labelPosition="after"
              labelAlign="left"
              style={{ marginBottom: 0, width: 70, float: "left" }}
            >
              <CheckBox checked={user.isSubtitle} />
            </FormField>

            <FormField
              name="isSource"
              label="Source"
              labelPosition="after"
              labelAlign="left"
              style={{ marginBottom: 0, width: 70, float: "left" }}
            >
              <CheckBox checked={user.isSource} />
            </FormField>

            <FormField
              name="isMemo"
              label="Memo"
              labelPosition="after"
              labelAlign="left"
              style={{ marginBottom: 0, width: 70, float: "left" }}
            >
              <CheckBox checked={user.isMemo} />
            </FormField>

            <FormField
              name="isCaseSensitivity"
              style={{ marginBottom: 0, float: "left", width: "130px" }}
            >
              <CheckBox checked={user.isCaseSensitivity} />
              <Label style={{ margin: "0 5px" }}>Case Sensitivity</Label>
            </FormField>

            <div className="row col-12">
              <div className="col-10">
                <FormField

                  name="targetString"
                  labelPosition="after"
                  labelAlign="left"
                  style={{ marginBottom: 0, float: "left", width: "100%" }}
                >
                  <TextBox />
                </FormField>
              </div>

              <div className="col-2">
                <FormField style={{ width: "100%", float: "right" }}>
                  <button id="findAll_btn"
                    onClick={() => {
                      this.props.handelFind(user);

                      // this.handleSubmit.bind(this)
                    }}
                  >
                    Find
                  </button>
                </FormField>
              </div>
            </div>
          </div>
        </Form>

        {/*<p>{JSON.stringify(user)}</p>*/}
      </div>
    );

    return mainContent;
  }
}

FindAllView_input.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  findAllToSearch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  editTable: state.editTable,
  transOperation: state.transOperation,
});

export default connect(mapStateToProps, {
  findAllToSearch,
  setIsShowFindAllViewList,
})(withRouter(FindAllView_input));



// WEBPACK FOOTER //
// ./src/components/translations/objects/FindAllView_input.js